import { Error } from "@mui/icons-material";
import {
  FormControl,
  InputLabel,
  LinearProgress,
  MenuItem,
  Select,
} from "@mui/material";
import useCustomSearchParam from "../../hooks/useCustomSearchParam";
import useGetServices from "../../hooks/useGetServices";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";

export default function ServiceFilter({ param = "service", testId }) {
  const { t } = useTranslation();
  const { searchFn, searchParams } = useCustomSearchParam(param);
  const [selectedFilter, setSelectedFilter] = useState("");

  const { translatedServices, isLoading, error } = useGetServices();
  useEffect(() => {
    const serviceId = searchParams.get(param);
    if (serviceId) setSelectedFilter(serviceId);
    else {
      setSelectedFilter("");
    }
  }, [searchParams, param]);

  function handleFilterChange(_z, value) {
    setSelectedFilter(value);
    searchFn(value);
  }

  if (isLoading) return <LinearProgress sx={{ width: "100%" }} />;
  if (error && !isLoading) return <Error color="error" />;

  return (
    <FormControl fullWidth size="small">
      <InputLabel>{t("Service")}</InputLabel>
      <Select
        disabled={isLoading || error}
        value={selectedFilter}
        label={t("Service")}
        onChange={(e) => handleFilterChange(param, e.target.value)}
        SelectDisplayProps={{ ...(testId && { "data-testid": testId }) }}
      >
        <MenuItem value={null}>{t("Reset")}</MenuItem>
        {translatedServices?.map(({ id, title }) => (
          <MenuItem key={id} value={id}>
            {title}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
